import Mainbanner from "../assets/Mainbanner.png";
import card1 from "../assets/card1.png";
import card2 from "../assets/card2.png";
import card3 from "../assets/card3.png";
import card4 from "../assets/card4.png";
import card5 from "../assets/card5.png";
import card6 from "../assets/card6.png";
import card7 from "../assets/card7.png";
import Banner1 from "../assets/Banner1.png";
import Banner2 from "../assets/Banner2.png";
import Banner3 from "../assets/Banner3.png";
import Ind1 from "../assets/Ind1.png";
import Ind2 from "../assets/Ind2.png";
import Ind3 from "../assets/Ind3.png";
import Ind4 from "../assets/Ind4.png";
import Ind5 from "../assets/Ind5.png";
import Ind6 from "../assets/Ind6.png";

const brandImages = Array.from({ length: 39 }, (_, index) =>
  require(`../assets/brand${index + 1}.png`)
);

/** Bundled fallbacks when CMS image fields are empty */
export const HOME_FALLBACKS = {
  hero: {
    backgroundImage: Mainbanner,
    badge: "School & Office Essentials",
    title: "Learn Better.",
    titleLine2: "Work Smarter.",
    tagline:
      "Quality educational products and office supplies for students, teachers, and professionals.",
    features: ["Educational Products", "Office Supplies", "Fast Delivery"],
    primaryButtonText: "Shop Now",
    primaryButtonLink: "/products",
    secondaryButtonText: "Explore Categories",
    secondaryButtonLink: "/products",
    footerLine: "Best products. Best prices. Delivered to your doorstep.",
  },
  shopCategories: {
    subtitle: "Shop by Category",
    title: "Explore Our Product Categories",
    description:
      "Find everything you need for schools, offices, learning spaces, and creative work.",
    items: [
      { title: "Files & Folders", image: card1, link: "/products?category=files-folders", accentColor: "#ffb347" },
      { title: "Writing Instruments", image: card2, link: "/products?category=writing-instruments", accentColor: "#2f8f7f" },
      { title: "Office Equipment", image: card3, link: "/products?category=office-equipment", accentColor: "#c9704f" },
      { title: "Office Machinery", image: card4, link: "/products?category=office-machinery", accentColor: "#ffb347" },
      { title: "Early Primary & Secondary", image: card5, link: "/products?category=early-years-primary-secondary", accentColor: "#2f8f7f" },
      { title: "Sports & Leisure", image: card7, link: "/products?category=sports-leisure", accentColor: "#c9704f" },
      { title: "Arts & Crafts", image: card6, link: "/products?category=art-craft", accentColor: "#ffb347" },
    ],
  },
  carousel: {
    intervalMs: 3000,
    items: [
      { image: Banner1, buttonText: "Shop Now", link: "/products" },
      { image: Banner2, buttonText: "Shop Now", link: "/products" },
      { image: Banner3, buttonText: "Shop Now", link: "/products" },
    ],
  },
  industries: {
    subtitle: "Industries We Serve",
    title: "Trusted Across Every Industry",
    description:
      "Delivering premium office supplies, signage, printing and branding solutions to businesses across the UAE.",
    items: [
      { title: "Corporate Offices", description: "Office supplies, branding solutions, printing services tailored for modern workplaces.", image: Ind1 },
      { title: "Education", description: "Stationery, educational supplies, custom printing, and classroom essentials.", image: Ind2 },
      { title: "Healthcare", description: "Medical signage, office essentials, branding, labels, and display solutions.", image: Ind3 },
      { title: "Hospitality", description: "Hotel branding, promotional materials, guest supplies, and signage.", image: Ind4 },
      { title: "Construction", description: "Safety signs, site branding, project boards, and construction display solutions.", image: Ind5 },
      { title: "Retail", description: "Retail displays, promotional materials, POS solutions, signage, and branding.", image: Ind6 },
    ],
  },
  brandPartners: {
    subtitle: "Our Brand Partners",
    title: "Trusted Brands We Supply",
    description:
      "Quality office, stationery, and educational products from leading brands.",
    items: brandImages.map((img, i) => ({
      image: img,
      alt: `Brand ${i + 1}`,
      link: "",
    })),
  },
  featuredProducts: {
    subtitle: "Featured Products",
    title: "Popular Picks for You",
    description: "Hand-picked essentials for school, office, and everyday work.",
    buttonText: "Explore All Products",
    buttonLink: "/products",
    limit: 9,
    productIds: [],
    products: [],
  },
};

export function mergeHomeSection(sectionKey, apiSection) {
  const fallback = HOME_FALLBACKS[sectionKey];
  if (!apiSection) return fallback;

  const merged = {
    ...fallback,
    ...apiSection,
  };

  if (Array.isArray(apiSection.items)) {
    if (apiSection.items.length === 0 && fallback.items?.length) {
      merged.items = fallback.items;
    } else {
      merged.items = apiSection.items
        .filter((item) => item.isActive !== false)
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map((item, index) => {
          const fb = fallback.items?.[index] || {};
          return {
            ...fb,
            ...item,
            image: item.image || fb.image || "",
          };
        });
    }
  }

  if (sectionKey === "hero") {
    merged.backgroundImage =
      apiSection.backgroundImage || fallback.backgroundImage;
    merged.features =
      apiSection.features?.length > 0 ? apiSection.features : fallback.features;
  }

  return merged;
}

export function mergeHomeContent(apiContent) {
  if (!apiContent) return HOME_FALLBACKS;
  return {
    hero: mergeHomeSection("hero", apiContent.hero),
    shopCategories: mergeHomeSection("shopCategories", apiContent.shopCategories),
    carousel: mergeHomeSection("carousel", apiContent.carousel),
    industries: mergeHomeSection("industries", apiContent.industries),
    brandPartners: mergeHomeSection("brandPartners", apiContent.brandPartners),
    featuredProducts: {
      ...HOME_FALLBACKS.featuredProducts,
      ...apiContent.featuredProducts,
      products: apiContent.featuredProducts?.products || [],
    },
  };
}
